



const BADGE_ESTADO_SRV = {
    Borrador:      { bg: "rgba(var(--gris-suave-rgb), 0.1)",  color: "var(--gris-suave)", label: "Borrador" },
    Revision:      { bg: "rgba(var(--amarillo-warning-rgb), 0.15)",   color: "var(--dorado-oscuro)", label: "En revisión" },
    Aprobado:      { bg: "rgba(var(--verde-bootstrap-rgb), 0.1)",    color: "var(--verde-bootstrap)", label: "Aprobado" },
    Desaprobado:   { bg: "rgba(var(--rojo-error-rgb), 0.1)",    color: "var(--rojo-error)", label: "Desaprobado" },
    ErrorRevision: { bg: "rgba(var(--rojo-error-rgb), 0.1)",    color: "var(--rojo-error)", label: "Error revisión" },
    Pausado:       { bg: "rgba(var(--gris-suave-rgb), 0.12)", color: "var(--gris-495057)", label: "Pausado" },
};

function fmtPrecio(n) {
    if (!n && n !== 0) return null;
    return "$" + new Intl.NumberFormat("es-CO").format(n);
}

function TarjetaServicio({ servicio, onClickVer, onPausar }) {
    const est        = BADGE_ESTADO_SRV[servicio.estado] || BADGE_ESTADO_SRV.Borrador;
    const imagen     = (servicio.imagenes || []).find(Boolean) || null;
    const precios    = (servicio.paquetes || []).map(p => p.precio).filter(n => n > 0);
    const precioMin  = precios.length ? Math.min(...precios) : null;
    const precioMax  = precios.length ? Math.max(...precios) : null;
    const p          = servicio.proveedor;
    const nombreP    = p ? [p.nombre, p.apellido].filter(v => v && v !== "NA").join(" ") || `@${p.username}` : null;

    return (
        <div className="card border-0 shadow-sm rounded-4" style={{ cursor: "pointer" }} onClick={onClickVer}>
            <div className="card-body py-3 px-4">
                <div className="d-flex gap-4 align-items-start flex-wrap">
                    {imagen && (
                        <img src={imagen} alt={servicio.nombre} className="rounded-3 flex-shrink-0"
                            style={{ width: 80, height: 80, objectFit: "cover" }} />
                    )}
                    <div className="flex-grow-1 min-w-0">
                        <div className="d-flex align-items-center gap-2 flex-wrap mb-1">
                            <span className="fw-semibold text-dark fs-6">{servicio.nombre || "Sin nombre"}</span>
                            <span className="badge rounded-pill px-2 py-1" style={{ background: est.bg, color: est.color, fontSize: "0.72rem" }}>
                                {est.label}
                            </span>
                            {servicio.estado === "Borrador" && (() => {
                                const r = servicio.recordatorioEnviado || {};
                                if (!r.whatsapp && !r.klaviyo && !r.pushApp && !r.telefono) return (
                                    <span className="badge rounded-pill px-2 py-1" style={{ background: "rgba(var(--amarillo-warning-rgb), 0.15)", color: "var(--dorado-oscuro)", fontSize: "0.72rem" }}>
                                        <i className="bi bi-bell-slash me-1"></i>Sin notificar
                                    </span>
                                );
                                return (
                                    <>
                                        {r.whatsapp  && <span className="badge rounded-pill px-2 py-1" style={{ background: "rgba(var(--verde-whatsapp-rgb), 0.12)", color: "var(--verde-azulado)", fontSize: "0.72rem" }}><i className="bi bi-whatsapp me-1"></i>WA</span>}
                                        {r.klaviyo   && <span className="badge rounded-pill px-2 py-1" style={{ background: "rgba(var(--azul-bootstrap-cta-rgb), 0.1)",  color: "var(--azul-bootstrap-cta)", fontSize: "0.72rem" }}><i className="bi bi-envelope-fill me-1"></i>Email</span>}
                                        {r.pushApp   && <span className="badge rounded-pill px-2 py-1" style={{ background: "rgba(var(--violeta-bootstrap-rgb), 0.1)",   color: "var(--violeta-bootstrap)", fontSize: "0.72rem" }}><i className="bi bi-phone-fill me-1"></i>App</span>}
                                        {r.telefono  && (() => {
                                            const intentos  = r.telefonoIntentos  || 0;
                                            const resultado = r.telefonoResultado || "";
                                            if (resultado === "publicado")     return <span className="badge rounded-pill px-2 py-1" style={{ background: "rgba(var(--verde-bootstrap-rgb), 0.12)",   color: "var(--verde-bootstrap)", fontSize: "0.72rem" }}><i className="bi bi-check-circle-fill me-1"></i>Publicado ✓</span>;
                                            if (resultado === "no_quiere")     return <span className="badge rounded-pill px-2 py-1" style={{ background: "rgba(var(--rojo-error-rgb), 0.12)",   color: "var(--rojo-error)", fontSize: "0.72rem" }}><i className="bi bi-ban me-1"></i>No llamar</span>;
                                            if (resultado === "sin_respuesta") return <span className="badge rounded-pill px-2 py-1" style={{ background: "rgba(var(--gris-suave-rgb), 0.12)", color: "var(--gris-suave)", fontSize: "0.72rem" }}><i className="bi bi-telephone-x me-1"></i>Sin respuesta</span>;
                                            if (resultado === "pte_identidad") return <span className="badge rounded-pill px-2 py-1" style={{ background: "rgba(var(--azul-bootstrap-cta-rgb), 0.12)",  color: "var(--azul-bootstrap-cta)", fontSize: "0.72rem" }}><i className="bi bi-person-vcard me-1"></i>Pdte. identidad</span>;
                                            const c = intentos >= 3 ? "var(--rojo-error)" : intentos === 2 ? "var(--naranja-mapa)" : "var(--dorado-oscuro)";
                                            const bg = intentos >= 3 ? "rgba(var(--rojo-error-rgb), 0.12)" : intentos === 2 ? "rgba(var(--naranja-mapa-rgb), 0.12)" : "rgba(var(--amarillo-warning-rgb), 0.15)";
                                            return <span className="badge rounded-pill px-2 py-1" style={{ background: bg, color: c, fontSize: "0.72rem" }}><i className="bi bi-telephone-fill me-1"></i>{intentos} intento{intentos !== 1 ? "s" : ""}</span>;
                                        })()}
                                    </>
                                );
                            })()}
                        </div>
                        <div className="text-muted small d-flex flex-wrap gap-3 mb-2">
                            {servicio.ciudad && servicio.ciudad !== "NA" && <span><i className="bi bi-geo-alt me-1"></i>{servicio.ciudad}</span>}
                            {servicio.tipoServicio && <span><i className="bi bi-laptop me-1"></i>{servicio.tipoServicio}</span>}
                            {precioMin !== null && (
                                <span>
                                    <i className="bi bi-cash me-1"></i>
                                    {precioMin === precioMax ? fmtPrecio(precioMin) : `${fmtPrecio(precioMin)} – ${fmtPrecio(precioMax)}`}
                                </span>
                            )}
                        </div>
                        {p && (
                            <div className="d-flex align-items-center gap-2 flex-wrap">
                                <img
                                    src={p.avatar || "/imagenes/marca/avatar.png"}
                                    alt={p.username}
                                    className="rounded-circle flex-shrink-0"
                                    style={{ width: 22, height: 22, objectFit: "cover" }}
                                />
                                <span className="text-muted" style={{ fontSize: "0.78rem" }}>
                                    {nombreP}{p.username ? ` · @${p.username}` : ""}
                                </span>
                                {p.correo && p.correo !== "NA" && (
                                    <span className="text-muted" style={{ fontSize: "0.78rem" }}>
                                        <i className="bi bi-envelope me-1"></i>{p.correo}
                                    </span>
                                )}
                                {p.telefono && p.telefono !== "NA" && (
                                    <span className="text-muted" style={{ fontSize: "0.78rem" }}>
                                        <i className="bi bi-telephone me-1"></i>{p.telefono}
                                    </span>
                                )}
                                {servicio.estado === "Borrador" && p.telefono && p.telefono !== "NA" && (() => {
                                    const tel    = p.telefono.replace(/\D/g, "");
                                    const telInt = tel.startsWith("57") ? tel : `57${tel}`;
                                    const msg =
`Hola ${nombreP}

Somos el equipo de *Zervicy* y notamos que tienes un servicio pendiente de publicar.

Queremos ayudarte a terminarlo *gratis y sin complicaciones*. Solo sigue este enlace, serás dirigido a nuestro WhatsApp de soporte, cuéntanos tu usuario o correo registrado y uno de nosotros te guía paso a paso hasta que tu servicio esté publicado:

https://www.zervicy.com/soporte-wapp

¡Te esperamos!`;
                                    return (
                                        <button
                                            type="button"
                                            className="btn btn-sm rounded-3 d-inline-flex align-items-center gap-1 fw-semibold"
                                            style={{ background: "var(--verde-whatsapp)", color: "var(--blanco)", fontSize: "0.72rem", padding: "2px 8px" }}
                                            onClick={e => { e.stopPropagation(); window.open(`https://wa.me/${telInt}?text=${encodeURIComponent(msg)}`, "_blank", "noopener,noreferrer"); }}
                                        >
                                            <i className="bi bi-whatsapp"></i>WhatsApp
                                        </button>
                                    );
                                })()}
                            </div>
                        )}
                    </div>
                    <div className="d-flex flex-column align-items-end gap-2 flex-shrink-0">
                        <i className="bi bi-chevron-right text-muted"></i>
                        {onPausar && (
                            <button
                                type="button"
                                className="btn btn-outline-warning btn-sm rounded-3 d-inline-flex align-items-center gap-1"
                                style={{ fontSize: "0.72rem", padding: "2px 8px" }}
                                onClick={e => { e.stopPropagation(); onPausar(); }}
                            >
                                <i className="bi bi-pause-circle"></i>Pausar
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TarjetaServicio;